import React from "react";
import {
  Box,
  Flex,
  Text,
  Image,
  Button,
  VStack,
  Checkbox,
  FormLabel,
  FormControl,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/logo.png";
import CustomInput from "components/input";
import img1 from "../../assets/four-kids.png";

const JoinOurCommunity = () => {
  const navigate = useNavigate();

  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      bg="white"
      border="1px solid #2a4567"
      position="relative"
      boxShadow="0px 4px 20px rgba(0, 0, 0, 0.25)"
    >
      {/* Left Content */}
      <Box
        flex={1}
        justifyContent="center"
        alignItems="center"
        display={"flex"}
      >
        <VStack align="flex-center" spacing={4} width={400}>
          <Image src={logo} width={"425px"} height={"100px"} />
          <Text
            fontFamily={"PlusJakartaSansMedium"}
            fontSize={"36px"}
            lineHeight={"38px"}
            color={"#000000"}
            textAlign={"center"}
          >
            Join our community
          </Text>
          <Text
            fontFamily={"PlusJakartaSansRegular"}
            fontSize={"16px"}
            lineHeight={"28px"}
            textAlign={"center"}
            color={"#898989"}
          >
            Start your journey with our KWC
          </Text>
          <VStack align="flex-center" spacing={4}>
            <CustomInput
              label={"First Name"}
              onChange={() => {}}
              placeholder={"Enter Your First Name"}
              type={"text"}
            />
            <CustomInput
              label={"Last Name"}
              onChange={() => {}}
              placeholder={"Enter Your Last Name"}
              type={"text"}
            />
            <CustomInput
              label={"Email Address"}
              onChange={() => {}}
              placeholder={"Enter Your Email Address"}
              type={"text"}
            />
          </VStack>
          <Flex display="flex" alignItems="center">
            <FormControl
              display="flex"
              alignItems="center"
              gap={2}
              //   justifyContent="space-between"
            >
              <Checkbox
                id="remember-me"
                colorScheme={"blue"}
                paddingBottom={1.5}
              />
              <FormLabel
                htmlFor="remember-me"
                color={"#000000"}
                fontFamily={"PlusJakartaSansMedium"}
                fontSize={"12px"}
                lineHeight={"18px"}
              >
                Remember Me
              </FormLabel>
            </FormControl>
            <Button
              alignSelf={"flex-start"}
              //   onClick={handleForgotPassword}
              bg={"transparent"}
              fontSize={12}
              _hover={{
                bg: "transparent",
              }}
            >
              <Text
                color={"#456EFF"}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansSemiBold"}
              >
                Forgot your password?
              </Text>
            </Button>
          </Flex>
          <VStack>
            <Button
              bgColor={"#456EFF"}
              colorScheme="#456EFF"
              borderRadius={"12px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"16px"}
              lineHeight={"20px"}
              color={"#FFFFFF"}
              textAlign={"center"}
              w={"100%"}
              h={"48px"}
              onClick={() => navigate("/success")}
            >
              Request to Sell
            </Button>
          </VStack>
          <Flex justifyContent={"center"} alignItems={"center"} gap={1}>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"12px"}
              lineHeight={"18px"}
              color={"#000000"}
            >
              Already have an account?
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"12px"}
              lineHeight={"18px"}
              color={"#456EFF"}
              cursor={"pointer"}
              textDecoration={"underline"}
              onClick={() => navigate("/login")}
            >
              Sign In
            </Text>
          </Flex>
        </VStack>
      </Box>
      {/* Right Image */}
      <Box flex={1}>
        <Image
          src={img1}
          alt="Kids Fashion"
          objectFit="cover"
          width={589}
          height={440}
        />
      </Box>
    </Flex>
  );
};

export default JoinOurCommunity;
